import { cva } from 'class-variance-authority';

export const dividerStyles = cva(['border-0'], {
  variants: {
    intent: {
      primary: 'bg-brand-200',
      quaternary: 'bg-quaternary-200',
    },
    variant: {
      normal: 'bg-quaternary-200',
      subtle: 'bg-quaternary-100',
      strong: 'bg-quaternary-300',
    },
    size: {
      sm: 'h-px',
      md: 'h-[2px]',
      lg: 'h-[3px]',
    },
  },
  compoundVariants: [
    // Primary intent with all variants
    {
      intent: 'primary',
      variant: 'normal',
      class: 'bg-brand-200',
    },
    {
      intent: 'primary',
      variant: 'subtle',
      class: 'bg-brand-100',
    },
    {
      intent: 'primary',
      variant: 'strong',
      class: 'bg-brand-300',
    },
    // Tertiary intent with all variants
    {
      intent: 'quaternary',
      variant: 'normal',
      class: 'bg-quaternary-200',
    },
    {
      intent: 'quaternary',
      variant: 'subtle',
      class: 'bg-quaternary-100',
    },
    {
      intent: 'quaternary',
      variant: 'strong',
      class: 'bg-quaternary-300',
    },
  ],
  defaultVariants: {
    intent: 'quaternary',
    variant: 'normal',
    size: 'sm',
  },
});
